<!-- Hero Section -->
<div class="softwaredev-section-bg">
  <section class="softwaredev-section container py-5">
    <div class="glass-panel-container">
      <div class="row align-items-center">
        <div class="col-lg-5">
          <h1 class="softwaredev-heading mb-3">
            Introduction to Design Patterns
          </h1>
          <!-- <h3 class="softwaredev-subheading2 mb-4">
            Discover the fresh stories of Kalpita Technologies.
          </h3> -->
          <div class="mb-5 contact-btn">
            <!-- <button class="btn case-study-btn me-3" (click)="goToCaseStudies()">
              Case Studies
            </button> -->
            <!-- <button class="btn hire-btn hire" (click)="exploreOurSolutions()">
              Explore Our Solutions
            </button> -->
          </div>
        </div>

        <div class="col-lg-7 text-center">
          <img src="../../../../assets/resources/whitepaper/designpatterns/design-patterns-bannerimg.gif"
            alt="Introduction to Design Patterns" class="img-fluid hero-image">
        </div>
      </div>
    </div>
  </section>
</div>
<!-- TL;DR Section with Image Icon -->
<section class="takeaways-section py-5">
  <div class="container">
    <h2 class="section-title text-center">TL;DR</h2>
    <div class="takeaways-list">
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
        <p>Design patterns are proven software design solutions that address recurring problems in application
          architecture, improving scalability, maintainability, and code quality.</p>
      </div>
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
        <p>Introduced by the Gang of Four (GoF), design patterns act as reusable templates that help developers build
          well-structured and efficient software systems.</p>
      </div>
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
        <p>The white paper categorizes design patterns into Creational, Structural, and Behavioural patterns, each
          solving different architectural challenges.</p>
      </div>
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
        <p>Creational patterns simplify and control object creation, reducing tight coupling and increasing flexibility
          in software systems.</p>
      </div>
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
        <p>Structural patterns focus on composing classes and objects efficiently to manage system complexity and
          improve scalability.</p>
      </div>
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
        <p>Behavioural patterns enhance object interaction and responsibility delegation, enabling adaptable workflows
          and maintainable logic.</p>
      </div>
    </div>
  </div>
</section>
<!-- Key Takeaways Section with Image Icon -->
<section class="takeaways-section pt-0 pb-5">
  <div class="container">
    <h2 class="section-title text-center">Key Takeaways</h2>
    <div class="takeaways-list">
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
        <p>Design patterns in software engineering improve software architecture quality by promoting reusable, clean,
          and organized code that adapts easily to change.</p>
      </div>
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
        <p>Using design patterns helps development teams reduce development time by relying on established best
          practices instead of reinventing solutions.</p>
      </div>
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
        <p>Creational design patterns (such as Singleton, Factory, Builder, and Prototype) abstract object instantiation
          to enhance flexibility and control.</p>
      </div>
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
        <p>Structural design patterns (like Adapter, Facade, Decorator, and Proxy) simplify complex systems by defining
          clear relationships between components.</p>
      </div>
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
        <p>Creational design patterns (such as Singleton, Factory, Builder, and Prototype) abstract object instantiation
          to enhance flexibility and control.Behavioural design patterns (including Observer, Command, Iterator, and
          Mediator) streamline communication and decision-making among objects.</p>
      </div>
      <div class="takeaway-item">
        <img src="../../../../assets/resources/whitepaper/arrow-indicator.svg" alt="Arrow" class="arrow-icon">
        <p>Adopting design patterns results in robust, scalable, and maintainable software systems, making them
          essential for modern enterprise and application development.</p>
      </div>
    </div>
    <button class="btn case-study-btn" (click)="openModal()">
      <i class="ri-download-2-line"></i> Download the Complete White Paper
    </button>
  </div>
</section>
<!-- Relavent Article -->
<app-relevant-whitepaper></app-relevant-whitepaper>

<!-- MODAL POPUP -->
<div class="modal-overlay" *ngIf="isModalOpen">
  <div class="modal-content-box">
    <button class="close-btn" (click)="closeModal()">&times;</button>

    <div class="modal-header" *ngIf="!submitSuccess">
      <h3>Download White Paper</h3>
      <p>Fill in your details to receive the white paper.</p>
    </div>

    <div *ngIf="submitSuccess" class="success-message text-center">
      <i class="ri-checkbox-circle-fill" style="color: #28a745; font-size: 3rem;"></i>
      <h4>Thank you!</h4>
      <p>Check your email for the download link.</p>
      <small style="color: #666;">Please check your spam folder if you don't see it.</small>
    </div>

    <form [formGroup]="downloadForm" (ngSubmit)="onSubmit()" *ngIf="!submitSuccess">
      <div class="form-group">
        <label>Full Name</label>
        <input type="text" formControlName="name" class="form-control" placeholder="Name">
        <div class="error-msg" *ngIf="downloadForm.get('name')?.touched && downloadForm.get('name')?.errors">

          <span *ngIf="downloadForm.get('name')?.errors?.['required']">
            Name is required
          </span>

          <span *ngIf="downloadForm.get('name')?.errors?.['pattern']">
            Name should contain only letters
          </span>

        </div>
      </div>

      <div class="form-group">
        <label>Email Address</label>
        <input type="email" formControlName="email" class="form-control" placeholder="Email">
        <div class="error-msg" *ngIf="downloadForm.get('email')?.touched && downloadForm.get('email')?.errors">

          <span *ngIf="downloadForm.get('email')?.errors?.['required']">
            Email is required
          </span>

          <span *ngIf="downloadForm.get('email')?.errors?.['pattern']">
            Enter a valid email address
          </span>

        </div>
      </div>

      <div class="alert alert-danger" *ngIf="errorMessage">{{ errorMessage }}</div>

      <div class="modal-footer">
        <button type="submit" class="submit-btn" [disabled]="isSubmitting">
          {{ isSubmitting ? 'Processing...' : 'Download Now' }}
        </button>
      </div>
    </form>
  </div>
</div>